export default __webpack_public_path__ + "static/back-login-cb7c9833eb058cdb7030b018bc095fe2.png";